
export const SCROLL_STATE_UP = "SCROLL_STATE_UP"

export const SCROLL_STATE_DOWN = "SCROLL_STATE_DOWN"
